//import Example from './example';
import Places from "./places";

document.addEventListener("DOMContentLoaded", function () {
    document
        .getElementById("locationSelector")
        .addEventListener("change", function () {
            const url = this.value;
            if (url) {
                window.location.href = url;
            }
        });

    if (document.getElementById("geolocateForm")) {
        const places = new Places({});
        places.init();

        /**
         * Lock-down form submissions
         */
        const form = document.getElementById("geolocateForm");
        const searchBtn = form.querySelector("button[type=submit]");
        const input = form.querySelector("#findCoordinates");
        const lat = form.querySelector("#latitude");
        const lng = form.querySelector("#longitude");

        // Disable button until coords have been set via Places
        searchBtn.disabled = true;

        // Enable after Places sets lat/lng
        const observer = new MutationObserver(() => {
            if (lat.value && lng.value) {
                searchBtn.disabled = false;
                searchBtn.click(); // Remove to disable immediate posting to WordPress
            }
        });
        observer.observe(lat, { attributes: true, attributeFilter: ["value"] });
        observer.observe(lng, { attributes: true, attributeFilter: ["value"] });

        // Clear coords if user types manually
        input.addEventListener("input", () => {
            lat.value = "";
            lng.value = "";
            searchBtn.disabled = true;
        });

        // Block submit if no coords
        form.addEventListener("submit", function (e) {
            if (!lat.value || !lng.value) {
                e.preventDefault();
                alert("Please select a location from the suggestions.");
            }
        });
    }
});
